export const common = {
  // Navigation
  nav_features: 'Tính năng',
  nav_security: 'Bảo mật',
  nav_community: 'Cộng đồng',
  nav_join: 'Tham gia ngay',
  nav_back_home: 'Về trang chủ',
  nav_new_project: 'DỰ ÁN MỚI',
  
  // New Projects Modal
  new_projects_title: 'Dự án mới',
  new_projects_subtitle: 'Khám phá các tính năng và cập nhật mới nhất',
  new_projects_close: 'Đóng',
  
  project1_title: 'Xác minh Video AI',
  project1_desc: 'Công nghệ AI tiên tiến để xác minh tính xác thực của nội dung video',
  project1_status: 'Sắp ra mắt',
  
  project2_title: 'Chợ toàn cầu',
  project2_desc: 'Mua và bán sản phẩm đã xác minh từ người bán đáng tin cậy trên toàn thế giới',
  project2_status: 'Đang phát triển',
  
  project3_title: 'Sự kiện trực tiếp',
  project3_desc: 'Tham gia các sự kiện phát trực tiếp với những người tham gia đã xác minh',
  project3_status: 'Đang thử nghiệm',
  
  project4_title: 'Trung tâm giáo dục',
  project4_desc: 'Học các kỹ năng mới với giảng viên và khóa học đã xác minh',
  project4_status: 'Sắp ra mắt',
  
  project5_title: 'Mạng lưới kinh doanh',
  project5_desc: 'Kết nối với các chuyên gia kinh doanh đã xác minh trên toàn cầu',
  project5_status: 'Đang phát triển',
  
  project6_title: 'Sức khỏe & Thể chất',
  project6_desc: 'Truy cập thông tin sức khỏe đã xác minh và các chương trình chăm sóc sức khỏe',
  project6_status: 'Đang lên kế hoạch',
  
  // Hero Section
  hero_title: 'FaceTrue',
  hero_subtitle: 'Mạng xã hội xác minh danh tính',
  hero_description_1: 'Không tài khoản giả. Không bắt nạt. Không bạo lực.',
  hero_description_2: 'Không độc hại. Không cực đoan.',
  hero_description_3: '100% tích cực - AI xác minh.',
  hero_explore_btn: 'Khám phá ngay',
  hero_signup_btn: 'Đăng ký miễn phí',
  
  // How It Works
  how_title: 'Cách hoạt động',
  step1_title: 'Xác thực khuôn mặt',
  step1_desc: 'Chụp ảnh selfie → AI xác thực danh tính → Xác minh ngay lập tức',
  step1_badge: 'Không tài khoản giả',
  step2_title: 'Nội dung sạch',
  step2_desc: 'AI lọc nội dung độc hại, lừa đảo, bạo lực 24/7',
  step2_badge: 'Lọc AI 24/7',
  step3_title: 'Cộng đồng toàn cầu',
  step3_desc: 'Đăng bài quốc gia hoặc toàn cầu',
  step3_badge: 'Các quốc gia trên thế giới',
  
  // Age-Based Content
  age_title: 'Nội dung theo độ tuổi',
  children_label: 'Độ tuổi 5-12',
  children_title: 'Không gian trẻ em',
  children_feature1: 'Nội dung an toàn & vui vẻ',
  children_feature2: 'Kiểm soát của phụ huynh',
  children_feature3: 'Trò chơi giáo dục',
  adults_label: 'Độ tuổi 18-59',
  adults_title: 'Cộng đồng người lớn',
  adults_feature1: 'Mạng lưới chuyên nghiệp',
  adults_feature2: 'Nhóm sở thích',
  adults_feature3: 'Kết nối thật',
  seniors_label: 'Độ tuổi 60+',
  seniors_title: 'Vòng tròn người cao tuổi',
  seniors_feature1: 'Giao diện dễ dùng',
  seniors_feature2: 'Sức khỏe & Thể chất',
  seniors_feature3: 'Kết nối gia đình',
  
  // Why Different
  why_title: 'Tại sao chọn FaceTrue',
  why_feature1_title: '100% người thật',
  why_feature1_desc: 'Xác thực danh tính bằng AI, loại bỏ tài khoản giả',
  why_feature2_title: 'Không bạo lực & độc hại',
  why_feature2_desc: 'AI lọc nội dung bạo lực, độc hại, nói xấu 24/7',
  why_feature3_title: 'Không chủ nghĩa cực đoan',
  why_feature3_desc: 'Loại bỏ mọi hình thức chủ nghĩa cực đoan và thù hận',
  why_feature4_title: '100% tích cực',
  why_feature4_desc: 'Chỉ nội dung tích cực, xây dựng và lành mạnh',
  why_feature5_title: 'An toàn cho mọi lứa tuổi',
  why_feature5_desc: 'Phân loại nội dung thông minh, phù hợp từng độ tuổi',
  why_feature6_title: 'Hệ thống cảnh báo 3 cờ',
  why_feature6_desc: '<span class="text-yellow-400 font-bold">Cờ Vàng</span> (lỗi lần 1) → <span class="text-red-400 font-bold">Cờ Đỏ</span> (lỗi lần 2) → <span class="text-gray-400 font-bold">Cờ Đen</span> (lỗi lần 3 - khóa tài khoản)',
  why_feature7_title: 'Hệ thống đánh giá sao',
  why_feature7_desc: 'Chia sẻ thông tin, hình ảnh, video tích cực → Nhận <span class="text-pink-400 font-bold">sao hình trái tim màu hồng</span> từ cộng đồng',
  why_feature8_title: 'Quảng cáo chân thực',
  why_feature8_desc: 'AI kiểm tra tính chân thực của quảng cáo. Hàng hóa được <span class="text-cyan-400 font-bold">kiểm chứng nguồn gốc</span> trước khi đăng tải',
  
  // Video Demo
  video_title: 'Video Demo FaceTrue',
  video_subtitle: 'Xem cách hoạt động',
  video_views: 'lượt xem',
  video_close: 'Bấm X để đóng',
  video_demo_live: 'DEMO TRỰC TIẾP',
  video_info: 'Demo mô phỏng FaceTrue',
  video_info_cta: 'Bấm Play để xem demo',
  video_update: 'Video thật sẽ được cập nhật từ Veo AI',
  
  // Video Stages
  scanning_title: 'Đang xác thực...',
  scanning_desc: 'AI đang kiểm tra danh tính',
  scanning_step1: 'Phát hiện khuôn mặt',
  scanning_step2: 'Xác thực AI',
  scanning_step3: 'Tạo hồ sơ...',
  scanning_badge: '100% Người thật',
  
  intro_step1_title: 'Xác thực thành công',
  intro_step1_subtitle: '100% người thật',
  intro_step2_title: 'AI lọc nội dung',
  intro_step2_subtitle: 'Không độc hại, không bạo lực',
  intro_step3_title: 'Kết nối toàn cầu',
  intro_step3_subtitle: '119 quốc gia',
  intro_step4_title: '100% tích cực',
  intro_step4_subtitle: 'Chỉ nội dung lành mạnh',
  intro_step5_title: 'An toàn mọi lứa tuổi',
  intro_step5_subtitle: 'Trẻ em • Người lớn • Người cao tuổi',
  
  stats_title: 'Cộng đồng FaceTrue',
  stats_subtitle: 'Đang phát triển mạnh mẽ',
  stats_users: 'Người dùng',
  stats_countries: 'Quốc gia',
  stats_posts: 'Bài viết tích cực',
  stats_badge: '100% Tích cực',
  
  comparison_title: 'Sự khác biệt',
  comparison_old: 'Mạng xã hội cũ',
  comparison_old_1: 'Tài khoản giả',
  comparison_old_2: 'Nội dung độc hại',
  comparison_old_3: 'Bạo lực',
  comparison_old_4: 'Lừa đảo',
  comparison_new: 'FaceTrue',
  comparison_new_1: '100% người thật',
  comparison_new_2: 'Nội dung sạch',
  comparison_new_3: '100% tích cực',
  comparison_new_4: 'An toàn AI',
  
  // Mock Posts
  mock_post1: 'Hôm nay thật tuyệt vời! Cảm ơn FaceTrue đã tạo ra môi trường tích cực 🌟',
  mock_post2: 'Chia sẻ kinh nghiệm làm việc tại nhà hiệu quả. Ai cần tips không? 💼',
  mock_post3: 'Công thức làm bánh mì healthy cho cả nhà. Ai thử chưa? 🍞',
  
  // CTA Section
  cta_title: 'Đăng ký ngay',
  cta_subtitle: 'Đăng ký phiên bản Beta của FaceTrue',
  cta_name: 'Họ và tên',
  cta_email: 'Email của bạn',
  cta_button: 'Đăng ký ngay',
  cta_submitting: 'Đang gửi...',
  cta_success: '🎉 Cảm ơn bạn! Chúng tôi sẽ liên hệ sớm nhất.',
  cta_error: '❌ Có lỗi xảy ra. Vui lòng thử lại.',
  cta_privacy: 'Chúng tôi tôn trọng quyền riêng tư của bạn',
  
  // Footer
  footer_copyright: '© 2025 FaceTrue - Mạng xã hội toàn cầu',
  footer_creator: 'Được tạo bởi Ben Nguyen',
  footer_powered: 'Công cụ tạo website',
  
  // Time
  time_hours_ago: '{{count}} giờ trước',
  time_day_ago: '{{count}} ngày trước',
  
  // Children Page
  children_nav_features: 'Tính năng',
  children_nav_safety: 'An toàn',
  children_nav_activities: 'Hoạt động',
  children_back_home: 'Về trang chủ',
  
  children_hero_title: 'Chào mừng đến với',
  children_hero_subtitle: 'Không gian trẻ em',
  children_hero_desc: 'Không gian an toàn, vui vẻ và giáo dục được thiết kế dành riêng cho trẻ em!<br />Nội dung 100% được phụ huynh chấp thuận với bảo vệ AI.',
  children_explore_btn: 'Khám phá tính năng',
  children_safety_btn: 'An toàn trước tiên',
  
  children_features_title: 'Tính năng vui & giáo dục',
  children_features_subtitle: 'Mọi thứ trẻ em cần để học, chơi và phát triển an toàn',
  
  children_feature1_title: 'Nội dung giáo dục',
  children_feature1_desc: 'Tài liệu học tập phù hợp độ tuổi, câu đố vui và bài học tương tác khiến giáo dục trở nên thú vị.',
  
  children_feature2_title: 'Trò chơi an toàn',
  children_feature2_desc: 'Các trò chơi được tuyển chọn cẩn thận, vui nhộn, giáo dục và hoàn toàn an toàn cho trẻ em.',
  
  children_feature3_title: 'Hoạt động sáng tạo',
  children_feature3_desc: 'Vẽ, tô màu, kể chuyện và các hoạt động sáng tạo khác để khơi dậy trí tưởng tượng.',
  
  safety_title: 'An toàn của con bạn là ưu tiên hàng đầu',
  safety_subtitle: 'Nhiều lớp bảo vệ để đảm bảo trải nghiệm không lo lắng',
  
  safety_feature1_title: 'Lọc nội dung AI',
  safety_feature1_desc: 'Giám sát AI 24/7 đảm bảo chỉ nội dung phù hợp đến với trẻ em.',
  
  safety_feature2_title: 'Kiểm soát của phụ huynh',
  safety_feature2_desc: 'Phụ huynh có thể giám sát hoạt động và đặt giới hạn thời gian sử dụng lành mạnh.',
  
  safety_feature3_title: 'Không người lạ',
  safety_feature3_desc: 'Trẻ em chỉ có thể tương tác với bạn bè và thành viên gia đình đã xác minh.',
  
  activities_title: 'Khám phá hoạt động vui',
  activities_subtitle: 'Nhấp vào bất kỳ hoạt động nào để tìm hiểu thêm và bắt đầu chơi!',
  
  activity1_title: 'Vẽ & Nghệ thuật',
  activity1_desc: 'Tạo tác phẩm nghệ thuật tuyệt vời với màu sắc và công cụ vẽ',
  
  activity2_title: 'Trò chơi giáo dục',
  activity2_desc: 'Học trong khi chơi với các trò chơi vui nhộn và thú vị',
  
  activity3_title: 'Đọc sách & Truyện',
  activity3_desc: 'Khám phá những câu chuyện kỳ diệu và phiêu lưu thú vị',
  
  activity4_title: 'Âm nhạc & Bài hát',
  activity4_desc: 'Nghe và hát theo những bài hát vui nhộn',
  
  activity5_title: 'Nhiếp ảnh & Video',
  activity5_desc: 'Chụp ảnh và tạo video sáng tạo an toàn',
  
  activity6_title: 'Hoạt động nhóm',
  activity6_desc: 'Chơi và học cùng bạn bè trong môi trường an toàn',
  
  activity7_title: 'Thử thách & Giải thưởng',
  activity7_desc: 'Hoàn thành thử thách và nhận huy hiệu đặc biệt',
  
  activity8_title: 'Hoạt động đặc biệt',
  activity8_desc: 'Khám phá các hoạt động mới mỗi tuần',
  
  children_activities_title: 'Khám phá hoạt động vui',
  children_activities_subtitle: 'Nhấp vào bất kỳ hoạt động nào để tìm hiểu thêm và bắt đầu chơi!',
  
  children_activity_drawing: 'Vẽ & Nghệ thuật',
  children_activity_drawing_desc: 'Tạo tác phẩm nghệ thuật tuyệt vời',
  children_activity_drawing_full: 'Thỏa sức sáng tạo với công cụ vẽ kỹ thuật số của chúng tôi! Tạo những kiệt tác đầy màu sắc, học các kỹ thuật nghệ thuật cơ bản và chia sẻ tác phẩm của bạn với bạn bè.',
  children_activity_drawing_participants: '45.000+ trẻ em đang tham gia',
  children_activity_drawing_feature1: 'Công cụ vẽ kỹ thuật số',
  children_activity_drawing_feature2: 'Trang tô màu',
  children_activity_drawing_feature3: 'Hướng dẫn nghệ thuật',
  children_activity_drawing_feature4: 'Chia sẻ tác phẩm',
  children_activity_drawing_feature5: 'Thử thách hàng tuần',
  
  children_activity_music: 'Âm nhạc & Bài hát',
  children_activity_music_desc: 'Nghe những bài hát vui nhộn',
  children_activity_music_full: 'Khám phá những bài hát vui nhộn, học nhạc cụ và tạo giai điệu của riêng bạn! Thưởng thức những bài hát giáo dục khiến việc học trở nên thú vị.',
  children_activity_music_participants: '38.000+ trẻ em đang tham gia',
  children_activity_music_feature1: 'Thư viện bài hát vui',
  children_activity_music_feature2: 'Trò chơi âm nhạc',
  children_activity_music_feature3: 'Học nhạc cụ',
  children_activity_music_feature4: 'Hát theo',
  children_activity_music_feature5: 'Tạo giai điệu',
  
  children_activity_stories: 'Truyện & Đọc sách',
  children_activity_stories_desc: 'Đọc những câu chuyện thú vị',
  children_activity_stories_full: 'Khám phá thế giới kỳ diệu với những câu chuyện tương tác! Đọc những câu chuyện thú vị, nghe sách nói và thậm chí tạo câu chuyện của riêng bạn.',
  children_activity_stories_participants: '52.000+ trẻ em đang tham gia',
  children_activity_stories_feature1: 'Truyện tương tác',
  children_activity_stories_feature2: 'Sách nói',
  children_activity_stories_feature3: 'Trò chơi đọc',
  children_activity_stories_feature4: 'Tạo truyện',
  children_activity_stories_feature5: 'Câu lạc bộ sách',
  
  children_activity_puzzles: 'Câu đố & Trò chơi',
  children_activity_puzzles_desc: 'Giải những thử thách vui',
  children_activity_puzzles_full: 'Thử thách trí não với những câu đố vui và trò chơi giáo dục! Giải những bí ẩn, hoàn thành thử thách và học trong khi chơi.',
  children_activity_puzzles_participants: '61.000+ trẻ em đang tham gia',
  children_activity_puzzles_feature1: 'Câu đố trí tuệ',
  children_activity_puzzles_feature2: 'Câu đố logic',
  children_activity_puzzles_feature3: 'Trò chơi toán học',
  children_activity_puzzles_feature4: 'Trò chơi chữ',
  children_activity_puzzles_feature5: 'Thử thách trí nhớ',
  
  children_activity_science: 'Khoa học & Khám phá',
  children_activity_science_desc: 'Khám phá và thí nghiệm',
  children_activity_science_full: 'Khám phá những điều kỳ diệu của khoa học! Tiến hành thí nghiệm ảo, tìm hiểu về thiên nhiên, không gian và khám phá cách mọi thứ hoạt động.',
  children_activity_science_participants: '29.000+ trẻ em đang tham gia',
  children_activity_science_feature1: 'Thí nghiệm ảo',
  children_activity_science_feature2: 'Khám phá thiên nhiên',
  children_activity_science_feature3: 'Phiêu lưu không gian',
  children_activity_science_feature4: 'Cách hoạt động',
  children_activity_science_feature5: 'Câu đố khoa học',
  
  children_activity_sports: 'Thể thao & Thể dục',
  children_activity_sports_desc: 'Giữ năng động và khỏe mạnh',
  children_activity_sports_full: 'Giữ năng động và khỏe mạnh! Tìm hiểu về các môn thể thao khác nhau, theo dõi các bài tập vui và theo dõi hành trình thể dục của bạn.',
  children_activity_sports_participants: '34.000+ trẻ em đang tham gia',
  children_activity_sports_feature1: 'Video tập thể dục',
  children_activity_sports_feature2: 'Học thể thao',
  children_activity_sports_feature3: 'Thử thách thể dục',
  children_activity_sports_feature4: 'Thói quen lành mạnh',
  children_activity_sports_feature5: 'Theo dõi hoạt động',
  
  children_activity_coding: 'Lập trình & Công nghệ',
  children_activity_coding_desc: 'Học lập trình',
  children_activity_coding_full: 'Học lập trình thông qua các trò chơi và dự án vui! Xây dựng các chương trình đơn giản, tạo hoạt ảnh và khám phá thế giới công nghệ.',
  children_activity_coding_participants: '27.000+ trẻ em đang tham gia',
  children_activity_coding_feature1: 'Lập trình khối',
  children_activity_coding_feature2: 'Dự án đơn giản',
  children_activity_coding_feature3: 'Trò chơi lập trình',
  children_activity_coding_feature4: 'Tạo hoạt ảnh',
  children_activity_coding_feature5: 'Cơ bản công nghệ',
  
  children_activity_nature: 'Thiên nhiên & Động vật',
  children_activity_nature_desc: 'Khám phá động vật hoang dã',
  children_activity_nature_full: 'Khám phá những động vật tuyệt vời và thiên nhiên xinh đẹp! Tìm hiểu về động vật hoang dã, thực vật và cách bảo vệ hành tinh của chúng ta.',
  children_activity_nature_participants: '41.000+ trẻ em đang tham gia',
  children_activity_nature_feature1: 'Sự thật về động vật',
  children_activity_nature_feature2: 'Video thiên nhiên',
  children_activity_nature_feature3: 'Học về thực vật',
  children_activity_nature_feature4: 'Hoạt động sinh thái',
  children_activity_nature_feature5: 'Câu đố động vật hoang dã',
  
  children_safety_title: 'An toàn của con bạn là ưu tiên hàng đầu',
  children_safety_subtitle: 'Nhiều lớp bảo vệ để đảm bảo trải nghiệm không lo lắng',
  
  children_safety1_title: 'Lọc nội dung AI',
  children_safety1_desc: 'Giám sát AI 24/7 đảm bảo chỉ nội dung phù hợp đến với trẻ em.',
  
  children_safety2_title: 'Kiểm soát của phụ huynh',
  children_safety2_desc: 'Phụ huynh có thể giám sát hoạt động và đặt giới hạn thời gian sử dụng lành mạnh.',
  
  children_safety3_title: 'Không người lạ',
  children_safety3_desc: 'Trẻ em chỉ có thể tương tác với bạn bè và thành viên gia đình đã xác minh.',
  
  children_safety4_title: 'Bảo vệ quyền riêng tư',
  children_safety4_desc: 'Thông tin cá nhân được mã hóa và không bao giờ chia sẻ với bên thứ ba.',
  
  children_footer_copyright: '© 2025 Khu vực trẻ em FaceTrue',
  children_footer_desc: 'Không gian an toàn cho trẻ em học và chơi',
  
  children_modal_safe_badge: 'An toàn & Vui',
  children_modal_what_you_can_do: 'Bạn có thể làm gì',
  children_modal_start_btn: 'Bắt đầu hoạt động',
  
  // Adults Page
  adults_nav_features: 'Tính năng',
  adults_nav_community: 'Cộng đồng',
  adults_nav_benefits: 'Lợi ích',
  adults_back_home: 'Về trang chủ',
  
  adults_hero_title: 'Kết nối với',
  adults_hero_subtitle: 'Người thật, Câu chuyện thật',
  adults_hero_desc: 'Tham gia cộng đồng người lớn đã xác minh chia sẻ trải nghiệm chân thực,<br />xây dựng kết nối ý nghĩa và cùng nhau phát triển.',
  adults_explore_btn: 'Khám phá tính năng',
  adults_join_btn: 'Tham gia cộng đồng',
  
  adults_features_title: 'Mọi thứ bạn cần để kết nối',
  adults_features_subtitle: 'Mạng lưới chuyên nghiệp, chia sẻ lối sống và cuộc trò chuyện ý nghĩa',
  
  adults_feature1_title: 'Nghề nghiệp & Chuyên nghiệp',
  adults_feature1_desc: 'Kết nối với các chuyên gia, chia sẻ thông tin nghề nghiệp và khám phá cơ hội trong lĩnh vực của bạn.',
  
  adults_feature2_title: 'Lối sống & Sở thích',
  adults_feature2_desc: 'Chia sẻ đam mê, sở thích và cuộc sống hàng ngày với những người có cùng chí hướng trên toàn thế giới.',
  
  adults_feature3_title: 'Cuộc trò chuyện sâu sắc',
  adults_feature3_desc: 'Tham gia thảo luận ý nghĩa về các chủ đề quan trọng với người dùng đã xác minh.',
  
  adults_community_title: 'Tham gia cộng đồng toàn cầu',
  adults_community_subtitle: 'Kết nối với những người chia sẻ sở thích và giá trị của bạn',
  
  adults_community_entrepreneurs: 'Doanh nhân',
  adults_community_entrepreneurs_desc: 'Ý tưởng kinh doanh & thảo luận khởi nghiệp',
  adults_community_entrepreneurs_full: 'Kết nối với những tâm hồn đổi mới và lãnh đạo doanh nghiệp từ khắp nơi trên thế giới. Chia sẻ ý tưởng khởi nghiệp, thảo luận chiến lược kinh doanh và tìm đồng sáng lập tiềm năng.',
  adults_community_entrepreneurs_members: '125.000+ thành viên',
  adults_community_entrepreneurs_topic1: 'Ý tưởng khởi nghiệp',
  adults_community_entrepreneurs_topic2: 'Tài trợ & Đầu tư',
  adults_community_entrepreneurs_topic3: 'Chiến lược kinh doanh',
  adults_community_entrepreneurs_topic4: 'Marketing & Tăng trưởng',
  adults_community_entrepreneurs_topic5: 'Phát triển sản phẩm',
  
  adults_community_health: 'Sức khỏe & Thể chất',
  adults_community_health_desc: 'Thể dục, dinh dưỡng & sức khỏe tinh thần',
  adults_community_health_full: 'Tham gia cộng đồng hỗ trợ tập trung vào sức khỏe thể chất và tinh thần. Chia sẻ thói quen tập luyện, mẹo dinh dưỡng và tài nguyên sức khỏe tinh thần.',
  adults_community_health_members: '230.000+ thành viên',
  adults_community_health_topic1: 'Thể dục & Tập luyện',
  adults_community_health_topic2: 'Dinh dưỡng & Chế độ ăn',
  adults_community_health_topic3: 'Sức khỏe tinh thần',
  adults_community_health_topic4: 'Yoga & Thiền định',
  adults_community_health_topic5: 'Lối sống lành mạnh',
  
  adults_community_arts: 'Nghệ thuật & Văn hóa',
  adults_community_arts_desc: 'Biểu hiện sáng tạo & trao đổi văn hóa',
  adults_community_arts_full: 'Tôn vinh sự sáng tạo và đa dạng văn hóa. Chia sẻ tác phẩm nghệ thuật của bạn, khám phá nghệ sĩ mới và tham gia thảo luận văn hóa ý nghĩa.',
  adults_community_arts_members: '180.000+ thành viên',
  adults_community_arts_topic1: 'Nghệ thuật thị giác',
  adults_community_arts_topic2: 'Âm nhạc & Biểu diễn',
  adults_community_arts_topic3: 'Văn học',
  adults_community_arts_topic4: 'Phim & Nhiếp ảnh',
  adults_community_arts_topic5: 'Trao đổi văn hóa',
  
  adults_community_travel: 'Du lịch & Phiêu lưu',
  adults_community_travel_desc: 'Chia sẻ trải nghiệm & mẹo du lịch',
  adults_community_travel_full: 'Khám phá thế giới cùng những người đam mê du lịch. Chia sẻ trải nghiệm du lịch, nhận đề xuất điểm đến và tìm bạn đồng hành.',
  adults_community_travel_members: '310.000+ thành viên',
  adults_community_travel_topic1: 'Mẹo du lịch',
  adults_community_travel_topic2: 'Hướng dẫn điểm đến',
  adults_community_travel_topic3: 'Du lịch tiết kiệm',
  adults_community_travel_topic4: 'Thể thao mạo hiểm',
  adults_community_travel_topic5: 'Trải nghiệm văn hóa',
  
  adults_community_food: 'Ẩm thực & Nấu ăn',
  adults_community_food_desc: 'Công thức, nhà hàng & nghệ thuật ẩm thực',
  adults_community_food_full: 'Cộng đồng ngon miệng cho những người yêu thích ẩm thực và đầu bếp tại nhà. Chia sẻ công thức nấu ăn, đánh giá nhà hàng và cuộc phiêu lưu ẩm thực.',
  adults_community_food_members: '275.000+ thành viên',
  adults_community_food_topic1: 'Công thức & Nấu ăn',
  adults_community_food_topic2: 'Đánh giá nhà hàng',
  adults_community_food_topic3: 'Làm bánh & Tráng miệng',
  adults_community_food_topic4: 'Ẩm thực quốc tế',
  adults_community_food_topic5: 'Nhiếp ảnh ẩm thực',
  
  adults_community_technology: 'Công nghệ',
  adults_community_technology_desc: 'Xu hướng công nghệ & đổi mới',
  adults_community_technology_full: 'Luôn dẫn đầu xu hướng và đổi mới công nghệ. Thảo luận về các thiết bị mới nhất, lập trình, AI và tương lai của công nghệ.',
  adults_community_technology_members: '195.000+ thành viên',
  adults_community_technology_topic1: 'Lập trình & Phát triển',
  adults_community_technology_topic2: 'AI & Học máy',
  adults_community_technology_topic3: 'Thiết bị & Đánh giá',
  adults_community_technology_topic4: 'An ninh mạng',
  adults_community_technology_topic5: 'Tin tức công nghệ',
  
  adults_community_parenting: 'Làm cha mẹ',
  adults_community_parenting_desc: 'Cuộc sống gia đình & mẹo làm cha mẹ',
  adults_community_parenting_full: 'Hỗ trợ và lời khuyên cho cha mẹ ở mọi giai đoạn. Chia sẻ mẹo làm cha mẹ, thách thức và cùng nhau ăn mừng những cột mốc quan trọng.',
  adults_community_parenting_members: '340.000+ thành viên',
  adults_community_parenting_topic1: 'Mẹo làm cha mẹ',
  adults_community_parenting_topic2: 'Phát triển trẻ em',
  adults_community_parenting_topic3: 'Giáo dục',
  adults_community_parenting_topic4: 'Hoạt động gia đình',
  adults_community_parenting_topic5: 'Cân bằng công việc-cuộc sống',
  
  adults_community_education: 'Giáo dục',
  adults_community_education_desc: 'Học tập & phát triển cá nhân',
  adults_community_education_full: 'Người học suốt đời đoàn kết! Chia sẻ tài nguyên giáo dục, thảo luận chiến lược học tập và cùng nhau phát triển.',
  adults_community_education_members: '210.000+ thành viên',
  adults_community_education_topic1: 'Học trực tuyến',
  adults_community_education_topic2: 'Phát triển nghề nghiệp',
  adults_community_education_topic3: 'Học ngôn ngữ',
  adults_community_education_topic4: 'Thảo luận học thuật',
  adults_community_education_topic5: 'Mẹo học tập',
  
  adults_community_active: 'Cộng đồng hoạt động',
  adults_community_join_btn: 'Tham gia cộng đồng',
  adults_community_popular_topics: 'Chủ đề phổ biến',
  
  adults_benefits_title: 'Tại sao người lớn chọn FaceTrue',
  adults_benefits_subtitle: 'Mạng xã hội được xây dựng cho kết nối người lớn chân thực',
  
  adults_benefit1_title: 'Danh tính đã xác minh',
  adults_benefit1_desc: 'Kết nối với sự tự tin khi biết mọi người đều là người thật.',
  
  adults_benefit2_title: 'Không độc hại',
  adults_benefit2_desc: 'Lọc AI loại bỏ quấy rối, phát ngôn thù hận và nội dung tiêu cực.',
  
  adults_benefit3_title: 'Phạm vi toàn cầu',
  adults_benefit3_desc: 'Kết nối với người dùng đã xác minh trên 119 quốc gia trên toàn thế giới.',
  
  adults_benefit4_title: 'Ưu tiên quyền riêng tư',
  adults_benefit4_desc: 'Dữ liệu của bạn được bảo vệ bằng các biện pháp bảo mật cấp doanh nghiệp.',
  
  adults_footer_copyright: '© 2025 Cộng đồng người lớn FaceTrue',
  adults_footer_desc: 'Kết nối chân thực với người lớn đã xác minh trên toàn thế giới',
  
  // Seniors Page
  seniors_nav_features: 'Tính năng',
  seniors_nav_health: 'Sức khỏe',
  seniors_nav_community: 'Cộng đồng',
  seniors_back_home: 'Về trang chủ',
  
  seniors_hero_title: 'Cộng đồng',
  seniors_hero_subtitle: 'Dành cho người cao tuổi',
  seniors_hero_desc: 'Chia sẻ trí tuệ của bạn, giữ liên lạc với người thân,<br />và tận hưởng cộng đồng trực tuyến an toàn, hỗ trợ.',
  seniors_explore_btn: 'Khám phá tính năng',
  seniors_safety_btn: 'An toàn trước tiên',
  
  seniors_features_title: 'Bạn có thể làm gì trên FaceTrue',
  seniors_features_subtitle: 'Kết nối, chia sẻ và tận hưởng tương tác ý nghĩa',
  
  seniors_feature1_title: 'Kết nối gia đình',
  seniors_feature1_desc: 'Giữ liên lạc với các thành viên gia đình trên toàn cầu. Chia sẻ ảnh, video và cập nhật cuộc sống trong môi trường an toàn.',
  
  seniors_feature2_title: 'Chia sẻ câu chuyện của bạn',
  seniors_feature2_desc: 'Chia sẻ trải nghiệm cuộc sống, trí tuệ và ký ức của bạn với người khác. Câu chuyện của bạn quan trọng và truyền cảm hứng.',
  
  seniors_feature3_title: 'Kết bạn mới',
  seniors_feature3_desc: 'Kết nối với những người chia sẻ sở thích và sở thích của bạn. Xây dựng tình bạn ý nghĩa.',
  
  seniors_feature4_title: 'Sự kiện địa phương',
  seniors_feature4_desc: 'Khám phá và tham gia các hoạt động và sự kiện cộng đồng địa phương gần bạn.',
  
  seniors_feature5_title: 'Học kỹ năng mới',
  seniors_feature5_desc: 'Truy cập hướng dẫn, mẹo và hướng dẫn về công nghệ, sở thích và kỹ năng sống hàng ngày.',
  
  seniors_feature6_title: 'Nhóm hỗ trợ',
  seniors_feature6_desc: 'Tham gia cộng đồng hỗ trợ về sức khỏe, thể chất và thách thức cuộc sống. Bạn không đơn độc.',
  
  seniors_health_title: 'Tài nguyên sức khỏe & Thể chất',
  seniors_health_subtitle: 'Luôn được thông tin và khỏe mạnh với thông tin đáng tin cậy',
  
  seniors_health1_title: 'Mẹo sức khỏe',
  seniors_health1_desc: 'Lời khuyên sức khỏe hàng ngày, mẹo dinh dưỡng và hướng dẫn tập thể dục được thiết kế riêng cho người cao tuổi.',
  
  seniors_health2_title: 'Sức khỏe tinh thần',
  seniors_health2_desc: 'Hỗ trợ sức khỏe tinh thần, thực hành chánh niệm và quản lý căng thẳng.',
  
  seniors_health3_title: 'Nhắc nhở thuốc',
  seniors_health3_desc: 'Đặt lời nhắc cho thuốc và cuộc hẹn sức khỏe để theo dõi.',
  
  seniors_health4_title: 'Theo dõi hoạt động',
  seniors_health4_desc: 'Theo dõi các hoạt động hàng ngày, bước chân và ăn mừng các cột mốc sức khỏe của bạn.',
  
  seniors_community_title: 'Kết nối với cộng đồng của bạn',
  seniors_community_subtitle: 'Tìm sự hỗ trợ, chia sẻ trải nghiệm và tạo kết nối ý nghĩa',
  
  seniors_community_family: 'Kết nối gia đình',
  seniors_community_family_desc: 'Giữ gần gũi với các thành viên gia đình',
  seniors_community_family_full: 'Kết nối với các thành viên gia đình qua các thế hệ. Chia sẻ ảnh, video và ký ức với con cái và cháu của bạn. Luôn cập nhật về các sự kiện và cột mốc quan trọng của gia đình.',
  seniors_community_family_members: '2,8 triệu thành viên',
  seniors_community_family_topic1: 'Cập nhật gia đình',
  seniors_community_family_topic2: 'Chia sẻ ảnh',
  seniors_community_family_topic3: 'Cuộc gọi video',
  seniors_community_family_topic4: 'Sự kiện gia đình',
  seniors_community_family_topic5: 'Câu chuyện cháu',
  
  seniors_community_stories: 'Chia sẻ câu chuyện của bạn',
  seniors_community_stories_desc: 'Trải nghiệm cuộc sống & trí tuệ',
  seniors_community_stories_full: 'Chia sẻ trải nghiệm cuộc sống, trí tuệ và câu chuyện của bạn với thế hệ trẻ. Ký ức và bài học của bạn là kho báu quý giá có thể truyền cảm hứng và hướng dẫn người khác.',
  seniors_community_stories_members: '1,9 triệu thành viên',
  seniors_community_stories_topic1: 'Câu chuyện cuộc sống',
  seniors_community_stories_topic2: 'Sự kiện lịch sử',
  seniors_community_stories_topic3: 'Kinh nghiệm nghề nghiệp',
  seniors_community_stories_topic4: 'Bài học cuộc sống',
  seniors_community_stories_topic5: 'Lịch sử gia đình',
  
  seniors_community_friends: 'Kết bạn mới',
  seniors_community_friends_desc: 'Kết nối với bạn bè trên toàn thế giới',
  seniors_community_friends_full: 'Gặp gỡ và kết nối với những người cao tuổi khác chia sẻ sở thích, sở thích và trải nghiệm cuộc sống của bạn. Xây dựng tình bạn ý nghĩa và tận hưởng kết nối xã hội.',
  seniors_community_friends_members: '3,2 triệu thành viên',
  seniors_community_friends_topic1: 'Tình bạn',
  seniors_community_friends_topic2: 'Hoạt động xã hội',
  seniors_community_friends_topic3: 'Sở thích chung',
  seniors_community_friends_topic4: 'Trò chuyện nhóm',
  seniors_community_friends_topic5: 'Gặp mặt',
  
  seniors_community_events: 'Sự kiện địa phương',
  seniors_community_events_desc: 'Hoạt động cộng đồng & tụ họp',
  seniors_community_events_full: 'Khám phá các sự kiện, hoạt động và tụ họp địa phương được thiết kế cho người cao tuổi trong khu vực của bạn. Luôn năng động và gắn kết với cộng đồng địa phương của bạn.',
  seniors_community_events_members: '1,5 triệu thành viên',
  seniors_community_events_topic1: 'Sự kiện cộng đồng',
  seniors_community_events_topic2: 'Trung tâm người cao tuổi',
  seniors_community_events_topic3: 'Tụ họp xã hội',
  seniors_community_events_topic4: 'Hoạt động địa phương',
  seniors_community_events_topic5: 'Hội thảo',
  
  seniors_community_learning: 'Học kỹ năng mới',
  seniors_community_learning_desc: 'Không bao giờ ngừng phát triển & học hỏi',
  seniors_community_learning_full: 'Không bao giờ ngừng học hỏi! Truy cập các hướng dẫn dễ theo dõi, lớp học trực tuyến và nội dung giáo dục được thiết kế đặc biệt cho người cao tuổi. Học theo tốc độ của riêng bạn.',
  seniors_community_learning_members: '2,1 triệu thành viên',
  seniors_community_learning_topic1: 'Cơ bản công nghệ',
  seniors_community_learning_topic2: 'Nghệ thuật & Thủ công',
  seniors_community_learning_topic3: 'Lớp nấu ăn',
  seniors_community_learning_topic4: 'Học ngôn ngữ',
  seniors_community_learning_topic5: 'Sở thích',
  
  seniors_community_support: 'Nhóm hỗ trợ',
  seniors_community_support_desc: 'Tìm sự hiểu biết & khích lệ',
  seniors_community_support_full: 'Tìm sự hỗ trợ và hiểu biết từ những người khác chia sẻ các tình trạng sức khỏe hoặc tình huống cuộc sống tương tự. Chia sẻ trải nghiệm và nhận hỗ trợ tinh thần.',
  seniors_community_support_members: '1,7 triệu thành viên',
  seniors_community_support_topic1: 'Hỗ trợ sức khỏe',
  seniors_community_support_topic2: 'Hỗ trợ đau buồn',
  seniors_community_support_topic3: 'Hỗ trợ người chăm sóc',
  seniors_community_support_topic4: 'Bệnh mãn tính',
  seniors_community_support_topic5: 'Sức khỏe tinh thần',
  
  seniors_community_popular_topics: 'Chủ đề phổ biến:',
  seniors_community_join_btn: 'Tham gia cộng đồng',
  
  seniors_benefits_title: 'Tại sao người cao tuổi yêu thích FaceTrue',
  seniors_benefits_subtitle: 'Mạng xã hội tôn trọng và đánh giá cao kinh nghiệm của bạn',
  
  seniors_benefit1_title: 'Không lừa đảo hoặc gian lận',
  seniors_benefit1_desc: 'Bảo vệ AI chống lại kẻ lừa đảo và hoạt động gian lận.',
  
  seniors_benefit2_title: 'Văn bản lớn, rõ ràng',
  seniors_benefit2_desc: 'Giao diện dễ đọc được thiết kế để xem thoải mái.',
  
  seniors_benefit3_title: 'Hỗ trợ 24/7',
  seniors_benefit3_desc: 'Trợ giúp luôn có sẵn khi bạn cần hỗ trợ.',
  
  seniors_benefit4_title: 'Bảo vệ quyền riêng tư',
  seniors_benefit4_desc: 'Thông tin cá nhân của bạn luôn được giữ an toàn và riêng tư.',
  
  seniors_benefit5_title: 'Cộng đồng tôn trọng',
  seniors_benefit5_desc: 'Môi trường tích cực nơi mọi người đối xử với nhau bằng sự tôn trọng.',
  
  seniors_benefit6_title: 'Miễn phí sử dụng',
  seniors_benefit6_desc: 'Tất cả các tính năng có sẵn miễn phí cho bạn.',
  
  seniors_footer_copyright: '© 2025 Cộng đồng người cao tuổi FaceTrue',
  seniors_footer_desc: 'Không gian an toàn và hỗ trợ cho người cao tuổi kết nối',
};

export default common;